import VIEW_USER from '@/queries/viewUser.graphql'
import { addProps } from '@/utils/helpers'

export const viewUser = {
  viewUser: {
    query: VIEW_USER,
    loadingKey: 'loading',
    variables() {
      return addProps({
        id: this.$route.params.id
      })
    },
    result({ data }) {
      this.user = data.viewUser
    }
  }
}



// WEBPACK FOOTER //
// ./src/queries/index.js